import { Consts } from '../dependencies';

export const VAT_RATE = 0.21;
export const PAYMENT_METHOD = Consts.paymentMethod.CARD;
export const DOCUMENT_TYPE = Consts.documentType.INVOICE;
export const VAT_MODE = Consts.vatMode.BASE;
export const TAX_DEDUCTIBLE = true;
